import {NgModule} from '@angular/core';
import {CommonModule, } from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService as AuthGuard} from '../app/modules/auth/_services/auth-guard.service'
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';

const routes: Routes = [
  {
    path: '', redirectTo: '/auth/login', pathMatch: 'full'
  },
  {
    path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'delete-account',
    loadChildren: () => import('./modules/delete-account/delete-account.module').then(m => m.DeleteAccountModule)
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'app',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'auth'
  }
];



@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
    useHash: false
})
  ],
  exports: [],
})
export class AppRoutingModule {
}
